import { Button } from "../../../components/ui";

/**
 * The second step of Publish and Mark complete (console spec §3.4): what the
 * event would go out — or close — without, and the choice to go ahead anyway.
 * The shell renders it under the header once `readinessWarnings` has something
 * to say; with nothing to say the first click is the transition, as before.
 */
export function ReadinessStrip({
  label,
  warnings,
  pending,
  onConfirm,
  onCancel,
}: {
  /** "Publish" or "Complete" — the verb on the go-ahead button. */
  label: "Publish" | "Complete";
  warnings: string[];
  pending: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}) {
  return (
    <div
      role="region"
      aria-label={`Before you ${label.toLowerCase()}`}
      className="animate-slide-down rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900"
    >
      <p className="font-medium">Before you {label === "Publish" ? "publish" : "mark this complete"}:</p>
      <ul className="mt-1.5 list-disc space-y-0.5 pl-5">
        {warnings.map((w) => (
          <li key={w}>{w}</li>
        ))}
      </ul>
      <div className="mt-3 flex flex-wrap gap-2">
        <Button size="sm" onClick={onConfirm} disabled={pending}>
          {pending ? "Saving…" : `${label} anyway`}
        </Button>
        <Button size="sm" variant="ghost" onClick={onCancel} disabled={pending}>
          Not yet
        </Button>
      </div>
    </div>
  );
}
